import React from "react";
import me from "../../assets/images/me.jpeg";
import "./About.scss";
import Title from "../../components/Title/Title";
import Skills from "./components/skills/Skills";
import AboutItem from "./components/aboutItem/AboutItem";
import { BsFacebook, BsGithub, BsLinkedin } from "react-icons/bs";

const About = () => {
  return (
    <div className="page-container about">
      <Title heading={"About Me"} />
      <div className="row about-content">
        {/* <div
          data-aos="fade-up"
          data-aos-anchor-placement="top-bottom"
          data-aos-duration="800"
          className="col-lg-6  about-image"
        >
          <img src={me} alt="owner" />
        </div> */}
        <div className="col-lg-6 about-inner-content">
          <div className="about-text">
            <h2
              data-aos="fade-up"
              data-aos-anchor-placement="top-bottom"
              data-aos-duration="900"
            >
              I'm Lala Asgarova
            </h2>
            <p
              data-aos="fade-up"
              data-aos-anchor-placement="top-bottom"
              data-aos-duration="900"
            >
              I'm a Software Developer based in Azerbaijan. I specialize in
              building fully responsive and high-performance web applications
              using modern technologies. I’m a fast learner who thrives under
              pressure and consistently delivers clean, efficient solutions on
              time.
            </p>
          </div>
          <div className="row about-info-content">
            <div
              data-aos="fade-right"
              data-aos-duration="900"
              className="col-lg-6 col-md-6 col-sm-12 about-info"
            >
              <span>Email:</span>
              <span>
                <a href="mailto: lolaaskrova2@gmail.com">
                  lolaaskrova2@gmail.com
                </a>
              </span>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-4 socials">
            <span data-aos="fade-right">Socials:</span>
            <a
              data-aos="fade-right"
              data-aos-duration="900"
              href="https://github.com/lolaaskerova"
              target="_blank"
              rel="noreferrer"
            >
              <BsGithub />
            </a>
            <a
              data-aos="fade-right"
              data-aos-duration="800"
              href="https://www.linkedin.com/in/lala-asgarova-6384b4378/"
              target="_blank"
              rel="noreferrer"
            >
              <BsLinkedin />
            </a>
            <a
              data-aos="fade-right"
              data-aos-duration="800"
              href="https://www.facebook.com/profile.php?id=61584451688736"
              target="_blank"
              rel="noreferrer"
            >
              <BsFacebook />
            </a>
          </div>
        </div>
      </div>
      <Skills />
    </div>
  );
};

export default About;
